import { RequestService } from '@/api/services/request.service';
import { DocData } from '@/types/legal';

export const getLegalDocsData = async () => {
	const request = RequestService.getInstance();
	try {
		const { data } = await request.get<DocData[]>('/api_v1/document/');

		return data;
	} catch (error) {
		console.error(error);
		return [];
	}
};
